export default {
  default: () => import("/builds/common/airbaltic-com/investors/layouts/default.vue").then(m => m.default || m),
  full: () => import("/builds/common/airbaltic-com/investors/layouts/full.vue").then(m => m.default || m)
}